export const watchSessionToken = {
  initial: 'init',
  states: {
    init: {
      on: {
        FETCH_AUTH_TOKEN: {
          target: 'fetchNewAuthToken',
        },
        FETCH_REFRESHED_AUTH_TOKEN: {
          target: 'fetchRefreshedAuthToken',
        },
        FETCH_REFRESHED_AUTH_TOKEN_WITH_DEPENDENCIES: {
          target: 'fetchRefreshedAuthTokenWithDependencies',
        },
      },
    },
    fetchNewAuthToken: {
      invoke: {
        src: 'fetchAuthToken',
        onDone: [
          {
            target: 'init',
            actions: ['saveAuthToken'],
          },
        ],
      },
    },
    fetchRefreshedAuthToken: {
      invoke: {
        src: 'fetchRefreshedAuthToken',
        onDone: [
          {
            target: 'init',
            actions: 'fetchAuthToken',
            cond: 'isAuthTokenExpired',
          },
          {
            target: 'init',
            actions: ['saveRefreshedAuthToken'],
          },
        ],
      },
    },
    fetchRefreshedAuthTokenWithDependencies: {
      invoke: {
        src: 'fetchRefreshedAuthToken',
        onDone: [
          {
            target: 'init',
            actions: ['saveRefreshedAuthToken', 'fetchRecentlyPlayed'],
            cond: 'isAuthTokenInitialSetup',
          },
          {
            target: 'init',
            actions: ['saveRefreshedAuthToken', 'fetchRecentlyPlayed'],
          },
        ],
      },
    },
  },
};
